export default "__VITE_ASSET__C6ZF4FP4__"